import { isEmpty } from "lodash";
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import FilterControls from "../filter-controls";
import styles from "./collection-controls.scss";
import { deepClone } from "../../../utils/other/utilities";
import { CategoryService } from "../../../utils/filters";

// A quick fix for GOOD-7400. if need to expand, consider move to a neutral location
function getDisplayNameForCategoryFilter(item, name) {
  return CategoryService.getDisplayNameForFilter(item, name);
}

function getValueForCategoryFilter(item, value, name) {
  return CategoryService.getValueForFilter(item, value, name);
}

function defaultProperty() {
  return { id: -1, name: "Select property" };
}

function SingleValueCollectionFilterControls(props) {
  const { item, onUpdateFilter, conditionOptions } = props;

  const values =
    item.values?.map((x) => ({
      id: x,
      name: getDisplayNameForCategoryFilter(item, x),
      value: x,
    })) ?? [];
  values.sort((x, y) => (x.name > y.name ? 1 : -1));

  const selectedProperty = isEmpty(item.selectedProperties)
    ? defaultProperty()
    : deepClone(
        values.find((x) => x.value === item.selectedProperties) ??
          defaultProperty()
      );

  if (selectedProperty?.value != null) {
    selectedProperty.name = getValueForCategoryFilter(
      item,
      selectedProperty.value,
      selectedProperty.name
    );
  }

  const handleFilterPropertiesChange = (selectedProperty) => {
    onUpdateFilter(item.id, {
      selectedProperties: selectedProperty.value,
    });
  };

  const propertiesFilter = (
    <FilterDropdown
      selectedItemClassName={styles.filterConditionName}
      options={values}
      selectedItem={selectedProperty}
      handleClickItem={handleFilterPropertiesChange}
    />
  );

  return (
    <FilterControls
      item={item}
      onUpdateFilter={onUpdateFilter}
      propertyFilterComponent={propertiesFilter}
      conditionOptions={conditionOptions}
    />
  );
}

export default SingleValueCollectionFilterControls;
